import PhoneLineDataView from "./PhoneLineDataView";
import SydFilterProvider from "src/components/Common/UI/SydFilter/SydFilterContext";
import SearchPhoneLines from "./SearchPhoneLines";
import SydFilterView from "src/components/Common/UI/SydFilter/SydFilterView";

const defaultFilterData: IPhoneLineSearchForm = {
  providerID: "",
  sapCode: "",
  phoneNumber: "",
  pendingStatusID: "",
  deleted: "",
  unitID: "",
  unitType: "",
  removalDateFrom: "",
  removalDateTo: "",
  comments: "",
  descline: ""
}

const PhoneLines = () => {
  return (
      <SydFilterProvider
        defaultFilterData={defaultFilterData}
      >
        
        <SydFilterView  title="Αναζήτηση Τηλεφωνικής γραμμής">
          <SearchPhoneLines />
        </SydFilterView>

        <PhoneLineDataView />
      </SydFilterProvider>

  )

}
export default PhoneLines;

